import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const StudentShow = ({ match }) => {
	const {
		params: { contactID },
	} = match;

	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تفاصيل الرسالة",
				breadcrumb: "اتصل بنا",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/studentApplies/${contactID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="row">
				<div className="col-md-12">
					<div className="row">
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="name">الاسم</label>
								<input
									type="text"
									id="name"
									disabled
									value={data.studentName}
								/>
							</div>
						</div>

						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="email">الهاتف</label>
								<input type="email" id="email" disabled value={data.phone} />
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="phone">اسم المدرسة</label>
								<input
									type="text"
									id="phone"
									disabled
									value={data.schoolName}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="phone">المرحلة الدراسية</label>
								<input type="text" id="phone" disabled value={data.level} />
							</div>
						</div>
						{/* <div className="col-md-6">
							<div className="form-item">
								<label htmlFor="serviceType">نوع الخدمة</label>
								<input
									type="text"
									id="serviceType"
									disabled
									value={data.service_name}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="contract_period">مدة التعاقد</label>
								<input
									type="text"
									id="contract_period"
									disabled
									value={data.contract_period}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="required_professions">المهن المطلوبة</label>
								<input
									type="text"
									id="required_professions"
									disabled
									value={data.required_professions}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-item">
								<label htmlFor="employees_num">عدد العمالة المطلوبة</label>
								<input
									type="text"
									id="employees_num"
									disabled
									value={data.employees_num}
								/>
							</div>
						</div> */}
						{/* <div className="col-md-12">
							<div className="form-item">
								<label htmlFor="massage">الرسالة</label>
								<textarea rows={4} id="massage" disabled value={data.massage} />
							</div>
						</div> */}
					</div>
				</div>
			</div>
		</section>
	);
};

export default StudentShow;
